// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__pb_pZ"};